'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

___$insertStyle("/*\n* ink colors (with variations only for black and white)\n*/\n.login__popup {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: auto;\n  position: fixed;\n  z-index: 9999;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  background: rgba(0, 0, 0, 0.5);\n}\n.login__popup-content {\n  padding-top: 15px;\n  display: flex;\n  border-radius: 4px;\n  flex-direction: column;\n  max-height: 80%;\n  position: relative;\n  overflow: auto;\n  z-index: 10000;\n  background-color: #fff;\n}\n.login__popup-content__close {\n  z-index: 10001;\n  cursor: pointer;\n  position: absolute;\n  display: flex;\n  top: 0;\n  right: 0;\n  width: 50px;\n  height: 50px;\n}");
//# sourceMappingURL=PopUp.scss.js.map
